module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./OrderListView.js"));
	}, "OrderListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OrderListView!./src/pages/Store/Order/OrderListView.js
// module id = 1708
// module chunks = 418